import React, {useState,useEffect} from 'react'

function ContestPage() {
    const [show, setShow] = useState(true)
    const [data, setData] = useState()
    useEffect(() => {
        async function fetchData()
        {
          const res=await fetch (`https://api.codedigger.tech/contest/shortCode`,{
            method:"GET",
            headers:{
              "Content-Type":"application/json",
            }
          });
          res
            .json()
            .then(res => setData(res))
            .then(show => setShow(false));
        }
        fetchData();
      },[])
    return (
        <>
            {show === true ? <><h2>Contests</h2><h2>Loading</h2></>:
            <><h2>Contests</h2>
            {console.log(data)}
            <ul>
                {data.results.map((dat) => {
                    {console.log(dat)}
                    var link='/contest/shortCode/' + dat.contestId + '/standing';
                    return(
                        <li>
                        <a href={link}>{dat.name}</a>
                    </li>
                    )
                })}
            </ul>
            </>}
        </>
    )
}

export default ContestPage
